<template>
  <div
    class="c-section-heading"
    data-cont="big"
    v-if="!(data.backgroundText === '' && data.sectionTitle === '')"
    :class="data.sectionTitle === '' ? 'c-section-heading--hide' : false"
  >
    <p
      v-if="data.backgroundText !== ''"
      class="section__eyelet blur-text"
      :style="{ textAlign: data.orientationBackgroundText }"
      v-html="data.backgroundText"
      js-parallax=""
    >
      {{ data.backgroundText }}
    </p>
    <h2
      class="section__title"
      :style="{ textAlign: data.orientationTitle }"
      v-html="data.sectionTitle !== '' ? data.sectionTitle : ' '"
      :js-anim="data.sectionTitle !== '' ? 'text' : false"
      data-cont="small"
    >
    </h2>
  </div>
</template>

<script>
export default {
  name: 'sectionHeading',

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.c-section-heading {
  position: relative;
  padding-top: 60px;

  &--hide {
    height: 0;
  }

  .section__title,
  .section__eyelet {
    position: relative;
    width: 100%;
  }

  .section__title {
    margin: 0 auto;
  }

  .section__eyelet {
    position: absolute;
    top: 0;
    left: 0;


    font-size: font-size(xsl);
    line-height: 1.1;

    @include mq(ipadP) {
      font-size: font-size(xml);
    }

    @include mq(ds) {
      font-size: font-size(xxl);
      line-height: 0.85;
    }
  }
}
</style>
